module.exports = __webpack_public_path__ + "img/kma_thumbnail.38e03b46.jpg";